/**
 * What the campaign becomes once a rider adds it to their home screen.
 *
 * The platform's own manifest names Muggle Test and starts at its landing page,
 * so a rider who installed the site from a charity route would get a testing
 * product's app. These are swapped in per route alongside the tab icon.
 */

/** Manifest describing the campaign as an installed app. */
export const CAMPAIGN_MANIFEST_PATH = "/charity-manifest.json";

/**
 * The label under the icon on an iOS home screen.
 *
 * iOS reads this in preference to the document title, which carries the
 * platform's name and would put "Muggle Test" under the campaign's mark.
 */
export const CAMPAIGN_HOME_SCREEN_TITLE = "Ride to Rebuild";
